<div class="controls-container">
    <div class="controls-header">Icons</div>
    
    <pm-stack-panel class="icon-controls" [style.padding.px]="10">
        <pm-stack-panel Orientation="Vertical">
            <pm-label Label="IconClass"></pm-label>
            <pm-combo-box 
                Width="200px"
                [ItemsSource]="IconClassItemsSource"
                DisplayMemberPath="Name"
                [(SelectedItem)]="SelectedIconClass"
                ItemHeight="28">
            </pm-combo-box>
        </pm-stack-panel>

        <pm-stack-panel Orientation="Vertical" [style.padding-left.px]="10" [style.padding-right.px]="10">
            <pm-label Label="IconSize"></pm-label>
            <pm-combo-box 
                Width="200px"
                [ItemsSource]="IconSizeItemsSource"
                DisplayMemberPath="Item"
                [(SelectedItem)]="SelectedIconSize"
                ItemHeight="28">
            </pm-combo-box>
        </pm-stack-panel>
        <pm-stack-panel Orientation="Vertical">
            <pm-label Label="Background"></pm-label>
            <pm-combo-box         
                Width="200px"
                [ItemsSource]="BackgroundItemsSource"
                DisplayMemberPath="Name"
                [(SelectedItem)]="SelectedBackground"
                ItemHeight="28">
            </pm-combo-box>
        </pm-stack-panel>
    </pm-stack-panel>

    <div class="layout-cards {{Background}}">
        <div class="icon-item">
            <pm-icon-address-card [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-address-card>
        </div>
        <div class="icon-item">
            <pm-icon-angle-double-left [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-angle-double-left>
        </div>
        <div class="icon-item">
            <pm-icon-angle-double-right [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-angle-double-right>
        </div>
        <div class="icon-item">
            <pm-icon-angle-left [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-angle-left>
        </div>
        <div class="icon-item">
            <pm-icon-angle-right [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-angle-right>
        </div>
        <div class="icon-item">
            <pm-icon-arrows [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-arrows>
        </div>
        <div class="icon-item">
            <pm-icon-ban [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-ban>
        </div>
        <div class="icon-item">
            <pm-icon-bar-chart [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-bar-chart>
        </div>
        <div class="icon-item">
            <pm-icon-bars [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-bars>
        </div>
        <div class="icon-item">
            <pm-icon-bell [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-bell>
        </div>   
        <div class="icon-item">
            <pm-icon-bell-o [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-bell-o>
        </div>     
        <div class="icon-item">
            <pm-icon-calendar [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-calendar>
        </div>
        <div class="icon-item">
            <pm-icon-calendar-check [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-calendar-check>
        </div>
        <div class="icon-item">
            <pm-icon-calendar-clock [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-calendar-clock>
        </div>
        <div class="icon-item">
            <pm-icon-caret-down [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-caret-down>
        </div>
        <div class="icon-item">
            <pm-icon-check [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-check>
        </div>
        <div class="icon-item">
            <pm-icon-check-square-o [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-check-square-o>
        </div>
        <div class="icon-item">
            <pm-icon-cloud [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-cloud>
        </div>
        <div class="icon-item">
            <pm-icon-clock [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-clock>
        </div>        
        <div class="icon-item">
            <pm-icon-cogs [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-cogs>
        </div>
        <div class="icon-item">
            <pm-icon-collapse-all [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-collapse-all>
        </div>
        <div class="icon-item">
            <pm-icon-column-resize [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-column-resize>
        </div>
        <div class="icon-item">
            <pm-icon-cubes [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-cubes>
        </div>
        <div class="icon-item">
            <pm-icon-down-arrow [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-down-arrow>
        </div>
        <div class="icon-item">
            <pm-icon-ellipsis-h [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-ellipsis-h>
        </div>
        <div class="icon-item">
            <pm-icon-ellipsis-v [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-ellipsis-v>
        </div>
        <div class="icon-item">
            <pm-icon-envelope [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-envelope>
        </div>
        <div class="icon-item">
            <pm-icon-eraser [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-eraser>
        </div>
        <div class="icon-item">
            <pm-icon-excel [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-excel>
        </div>
        <div class="icon-item">
            <pm-icon-exchange [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-exchange>
        </div>
        <div class="icon-item">
            <pm-icon-exclamation-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-exclamation-circle>
        </div>
        <div class="icon-item">
            <pm-icon-exclamation-triangle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-exclamation-triangle>
        </div>
        <div class="icon-item">
            <pm-icon-expand-all [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-expand-all>
        </div>
        <div class="icon-item">
            <pm-icon-files-o [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-files-o>
        </div>        
        <div class="icon-item">
            <pm-icon-file-text [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-file-text>
        </div>
        <div class="icon-item">
            <pm-icon-file-text-o [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-file-text-o>
        </div>
        <div class="icon-item">
            <pm-icon-filter [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-filter>
        </div>
        <div class="icon-item">
            <pm-icon-folder-open [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-folder-open>
        </div>        
        <div class="icon-item">
            <pm-icon-gear [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-gear>
        </div>
        <div class="icon-item">
            <pm-icon-home [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-home>
        </div>
        <div class="icon-item">
            <pm-icon-info-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-info-circle>
        </div>
        <div class="icon-item">
            <pm-icon-key [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-key>
        </div>
        <div class="icon-item">
            <pm-icon-left-arrow [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-left-arrow>
        </div>
        <div class="icon-item">
            <pm-icon-level-down [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-level-down>
        </div>
        <div class="icon-item">
            <pm-icon-line-chart [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-line-chart>
        </div>
        <div class="icon-item">
            <pm-icon-link [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-link>
        </div>
        <div class="icon-item">
            <pm-icon-lost-connection [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-lost-connection>
        </div>        
        <div class="icon-item">
            <pm-icon-long-arrow-down [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-long-arrow-down>
        </div>
        <div class="icon-item">
            <pm-icon-long-arrow-up [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-long-arrow-up>
        </div> 
        <div class="icon-item">
            <pm-icon-mail-forward [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-mail-forward>
        </div>         
        <div class="icon-item">
            <pm-icon-pause [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-pause>
        </div>
        <div class="icon-item">
            <pm-icon-pencil [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-pencil>
        </div>
        <div class="icon-item">
            <pm-icon-pending [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-pending>
        </div>        
        <div class="icon-item">
            <pm-icon-pie-chart [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-pie-chart>
        </div>
        <div class="icon-item">
            <pm-icon-play [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-play>
        </div>
        <div class="icon-item">
            <pm-icon-plus [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-plus>
        </div>
        <div class="icon-item">
            <pm-icon-question-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-question-circle>
        </div>
        <div class="icon-item">
            <pm-icon-refresh [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-refresh>
        </div>
        <div class="icon-item">
            <pm-icon-right-arrow [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-right-arrow>
        </div>
        <div class="icon-item">
            <pm-icon-running [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-running>
        </div>
        <div class="icon-item">
            <pm-icon-search [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-search>
        </div>
        <div class="icon-item">
            <pm-icon-search-minus [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-search-minus>
        </div>
        <div class="icon-item">
            <pm-icon-search-plus [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-search-plus>
        </div>
        <div class="icon-item">
            <pm-icon-shield [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-shield>
        </div>
        <div class="icon-item">
            <pm-icon-sort-amount-asc [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-sort-amount-asc>
        </div>
        <div class="icon-item">
            <pm-icon-sort-amount-desc [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-sort-amount-desc>
        </div>
        <div class="icon-item">
            <pm-icon-star [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-star>
        </div>
        <div class="icon-item">
            <pm-icon-stop-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-stop-circle>
        </div>
        <div class="icon-item">
            <pm-icon-th [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-th>
        </div>
        <div class="icon-item">
            <pm-icon-times [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-times>
        </div>
        <div class="icon-item">
            <pm-icon-times-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-times-circle>
        </div>
        <div class="icon-item">
            <pm-icon-train [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-train>
        </div>        
        <div class="icon-item">
            <pm-icon-up-arrow [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-up-arrow>
        </div>
        <div class="icon-item">
            <pm-icon-user-circle [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-user-circle>
        </div>
        <div class="icon-item">
            <pm-icon-window-maximize [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-window-maximize>
        </div>
        <div class="icon-item">
            <pm-icon-window-minimize [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-window-minimize>
        </div>
        <div class="icon-item">
            <pm-icon-window-restore [IconSize]="IconSize" [IconClass]="IconClass"></pm-icon-window-restore>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/icons/icons.html